<template>
  <ExternalList
      headline="Latest Opportunities"
      endpoint="/api/v2/opportunities"
      :default-page-size="10"
      :endpoint-filters="{project_id: project.id, status:'new'}"
      :headlines="headlines"
      :show-list-actions="false"
      :show-checkboxes="false"
      :show-buttons="false"
      :show-pagination="false"
      :page-size-options="null"
      :can-show="() => false"
      :can-destroy="() => false"
  >
    <template v-slot:default="{ row: opportunity }">
      <td class="table__ellipsis">
        <router-link :to="'/companies/' + opportunity.attributes.company_id">
          {{ opportunity.attributes.company_name }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        {{ opportunity.attributes.value | price }}
      </td>
    </template>

    <template #headline-right>
      <router-link to="project-opportunities" class="btn btn-white btn-sm" style="margin-top: 4px;">
        <i class="fa fa-search"></i> Show all
      </router-link>
    </template>
  </ExternalList>
</template>

<script>
import ExternalList from "../../../../Panels/Lists/External.vue";

export default {
  components: {ExternalList},

  props: {
    project: {
      required: true
    }
  },

  data() {
    return {
      editing: null
    }
  },

  computed: {
    headlines() {
      return [
        {width: 12, text: 'Company'},
        {width: 12, text: 'Value'},
      ]
    },
  }
}
</script>
